import { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import DownIcon from "../../assets/svg/downIcon.svg";
import DaburModel from "./DaburModel";

export default function DaburDropDown({
  sidebarOpen,
  isMobile,
  modelSelectorConfig,
}) {
  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  

const ModelName = modelSelectorConfig?.modelOptions[modelSelectorConfig?.modelName]
const modelData = modelSelectorConfig?.modelList?.find(
  item => item.modelName === ModelName
)

  return (
    <div className="relative" ref={dropdownRef}>
      <div
        onClick={toggleDropdown}
        className={`cursor-pointer rounded-lg bg-white w-full h-8 flex flex-row items-center justify-start p-2 box-border gap-2 text-left text-sm font-hel ${
          isMobile && !sidebarOpen ? "ml-2" : "ml-[16rem]"
        }`}
      >
        {modelSelectorConfig ? (
          <>
          <div className="flex flex-col gap-[2px">
            <span className="relative text-md tracking-[0.01em]">{(modelData?.modelId?.charAt(0)?.toUpperCase() + modelData?.modelId?.slice(1)) || "DaburGPT"}</span>
              {modelData?.description && <p className=" leading-[11px] text-[10px] text-gray-500">
                  {modelData?.description}
                </p>
              }
          </div>
          </>
            
        ) :( <span className="relative text-md tracking-[0.01em]"><strong>Dabur</strong>GPT</span>) }
       
        {modelSelectorConfig  &&
        <div className="w-4 h-4 flex flex-col items-center mt-[2px]">
          <img
            className="w-3 h-3 relative"
            alt="down icon"
            src={DownIcon}
          />
        </div>
        }
      </div>
      {isOpen && modelSelectorConfig && (
        <DaburModel setIsOpen={setIsOpen} sidebarOpen={sidebarOpen} isMobile={isMobile} modelSelectorConfig={modelSelectorConfig}/>
      )}
    </div>
  );
}

DaburDropDown.propTypes = {
  sidebarOpen: PropTypes.bool.isRequired,
  isMobile: PropTypes.bool.isRequired,
};